import { useState } from 'react';
import { RXRLOGO } from 'src/assets/logos/rxr';
import { OrganisationStartApplication } from 'src/components/OrganisationStartApplication/OrganisationStartApplication';
import { RXRPropertiesConfig } from 'src/configs/data/RxrProperties';

export const RXRApplication = () => {
  const [addresses] = useState(RXRPropertiesConfig);

  return (
    <OrganisationStartApplication
      addresses={addresses}
      logo={<RXRLOGO />}
      organisation="rxr"
    />
  );
};
